var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinFilled = function SvgLinkedinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    fillRule: "evenodd",
    d: "M26.889 2H5.11A3.11 3.11 0 0 0 2 5.111V26.89A3.11 3.11 0 0 0 5.111 30H26.89A3.11 3.11 0 0 0 30 26.889V5.11A3.11 3.11 0 0 0 26.889 2M10.466 26.111H6.29V12.628h4.177zM8.358 10.863a2.477 2.477 0 0 1-2.47-2.49 2.477 2.477 0 0 1 2.47-2.488 2.477 2.477 0 0 1 2.47 2.489 2.477 2.477 0 0 1-2.47 2.489M26.111 26.11h-4.153v-7.078c0-1.94-.74-3.025-2.271-3.025-1.673 0-2.544 1.128-2.544 3.025v7.078h-4.005V12.628h4.005v1.816s1.206-2.228 4.064-2.228 4.908 1.746 4.908 5.359v8.536h-.004Z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedinFilled;